'use es6';

import { getDemo } from '../../data/schemas/dashboardSchema';
import { useHasDemoDashboardWriteAccess } from '../scopes/hooks/useHasScope';
export const useIsReadOnlyDemoDashboard = dashboard => {
  const userCanWriteDemoDashboard = useHasDemoDashboardWriteAccess();
  return getDemo(dashboard) && !userCanWriteDemoDashboard;
};